module.exports = __webpack_public_path__ + "img/szechenyi2020.baeca6e9.png";